<template>
  <div class="popup" v-show="visible">
      <div class="popup--inner">
          <h2 class="popup--title">
              Edit Pricing Block
          </h2>
          <form novalidate v-on:submit.prevent="function(){return false}" class="popup--paragraph">
              <Message v-if="error" :message-content="error" message-status="error"></Message>
              <fieldset class="form--item">
                  <label class="label" for="">
                      Start time
                  </label>
                  <div class="input_text" id="link">
                    <el-time-select
                        v-model="starttime"
                        :picker-options="{
                            start: '00:00',
                            step: '00:15',
                            end: '23:30'
                        }"
                        placeholder="Click to select a start timeslot">
                    </el-time-select>
                  </div>
              </fieldset>
              <fieldset class="form--item">
                  <label class="label" for="">
                      End time
                  </label>
                  <div class="input_text" id="link">
                    <el-time-select
                        v-model="endtime"
                        :picker-options="{
                            start: '00:00',
                            step: '00:15',
                            end: '23:45',
                            minTime: starttime
                        }"
                        placeholder="Click to select a end timeslot">
                    </el-time-select>
                  </div>
              </fieldset>
              <fieldset class="form--item">
                  <label class="label" for="">
                      Multiplier
                  </label>
                  <div class="input_radioGroup">
                    <input type = "radio"
                        name = "multiplier"
                        id = "0"
                        v-model="price.multiplier"
                        value = "0" />
                    <label for = "0">0</label>
                    <input type = "radio"
                        name = "multiplier"
                        id = "1"
                        v-model="price.multiplier"
                        value = "1" />
                    <label for = "1">1</label>
                    <input type = "radio"
                        name = "multiplier"
                        id = "2"
                        v-model="price.multiplier"
                        value = "2" />
                    <label for = "2">2</label>
                    <input type = "radio"
                        name = "multiplier"
                        id = "3"
                        v-model="price.multiplier"
                        value = "3" />
                    <label for = "3">3</label>
                  </div>
              </fieldset>
          </form>
          <div class="popup--buttons">
              <a class="popup--buttons-item btn btn_grey btn_stroke" v-on:click="close">
                  Cancel
              </a>
              <a class="popup--buttons-item btn btn_green" v-on:click="validateBlock">
                  Save
              </a>
          </div>
      </div>
  </div>
</template>
<script>
  import Popup from 'vue-popup';
  import Message from '../Message';

  import { ObjectID } from 'bson';
  var moment = require('moment');
  require('vue-popup/lib/popup.css');
  export default {
      mixins: [Popup],
      components: {Message},
      props: {
        visible: false,
        resource: '',
        modal: {
          default: true
        },
        block: {

        },
        closeOnClickModal: {
          default: true
        }
      },
      data(){
        return {
          error: '',
          starttime: '',
          endtime: '',
          price: {
            multiplier: 1
          }
        }
      },
      watch: { 
        'visible' : function(newVal, oldVal) { // watch it
          if(newVal && !this.block.id){
            this.price = {multiplier: 1};
            this.starttime = '';
            this.endtime = '';
          }else if(newVal){
            this.price = JSON.parse(JSON.stringify(this.block));
            this.starttime = this.convertTimeslot(this.price.startSlot);
            this.endtime   = this.convertTimeslot(this.price.endSlot);
          }
        }
      },
      methods: {
        close() {
          this.$parent.togglePriceBlock();
        },
        confirm(){
          this.price.formatted_value = this.format();
          this.price.startSlot = this.getTimeslot(this.starttime);
          this.price.endSlot = this.getTimeslot(this.endtime);
          this.price.id = this.price.id || (new ObjectID()).toString();
          this.$parent.addPriceBlock(this.price);
        },
        isOverlapping(){
          let items = this.$parent.wall.pricingModifiers || [];
          this.price.startSlot = this.getTimeslot(this.starttime);
          this.price.endSlot = this.getTimeslot(this.endtime);
          for (var i = items.length - 1; i >= 0; i--) {
            if((Math.max(items[i].startSlot, this.price.startSlot) < Math.min( items[i].endSlot, this.price.endSlot)) && this.price.id != items[i].id){
              this.error = 'The time you selected overlaps another block which is not allowed';
              return true
            }
          }
          this.error = '';
          return false;
        },
        validateBlock(){
          if(!(this.starttime && this.endtime && this.price.multiplier) || this.isOverlapping()){
            return false;
          }
          this.error = '';
          return this.confirm();
        },
        getTimeslot(datetime){
          let time = datetime.split(":");
          let slot = time[0] * 4 + time[1] / 15;

          return ("00" + slot).slice(-2);
        },
        convertTimeslot(datetime){
          return ("00" + Math.floor(parseInt(datetime) / 4)).slice(-2) + ":" + ("00" + (parseInt(datetime) * 15 ) % 60 ).slice(-2)
        },
        format(val){
          return moment(this.starttime, "hh:mm").format("hh:mma") + ' to ' + moment(this.endtime, "hh:mm").format("hh:mma") + ' - x' + this.price.multiplier;
        }
      }
    };
</script>


// WEBPACK FOOTER //
// modal_price.vue?05f7001b